import React from "react";
import DropDownComponent from "../DropDownComponent";
import TextFieldComponentLarge from "../TextFieldComponentLarge";

function AdmissionAssessmentOutcome({
  assessmentStatus,
  handleAssessmentStatus,
  assessmentReason,
  handleAssessmentReason,
}) {
  return (
    <div
      className="container-main-plan margin-bottom-2"
      style={{ marginTop: 30 }}
    >
      <div className="tab-container-title-2B">Assessment outcome</div>

      <div className="tab-form-container-bis">
        <DropDownComponent
          api="status2"
          title="Status"
          value={assessmentStatus}
          onChange={handleAssessmentStatus}
          showValidation={true}
        />
      </div>

      <div className="tab-form-container-bis">
        <TextFieldComponentLarge
          title="Reason"
          value={assessmentReason}
          onChange={handleAssessmentReason}
          showValidation={true}
        />
      </div>
    </div>
  );
}

export default AdmissionAssessmentOutcome;

